export const uid = () =>
  (typeof crypto !== "undefined" && crypto.randomUUID)
    ? crypto.randomUUID().replace(/-/g, "").slice(0, 12)
    : Math.random().toString(36).slice(2, 9) + Date.now().toString(36).slice(-4);

export const PHASES = ["Aktif", "Post Production", "Tamamlandı", "Erken Aşama", "Değerlendirilecek"];

// Coral accent for active, muted for rest
export const PHASE_DOT = {
  "Aktif":             "#e4572e",
  "Post Production":   "#c9843a",
  "Tamamlandı":        "#888",
  "Erken Aşama":       "#4a90a4",
  "Değerlendirilecek": "#9b7ec8",
};

export const STATUS_OPTIONS = [
  "Pre-Production","Production","Geliştirme","Çekim",
  "Editing","Post-Production","Festival","Tamamlandı","Dağıtım","—"
];

// ISO country codes instead of flags
export const COUNTRY_CODES = [
  "TR","CZ","SK","RS","XK","FR","DE","CA","IR","VE",
  "PT","BR","AZ","MX","LT","US","PK","TN","KZ","KH",
  "ES","GB","IT","NL","BE","AT","CH","SE","NO","DK",
  "JP","KR","AR","CO","PL","UA","GR","HU","RO","HR"
];

export const CALENDAR_COLORS = [
  "#e4572e","#4a90a4","#7c6b9e","#5a8a5a","#c9843a",
  "#3a6ea8","#a85a7c","#6b8a3a","#8a3a3a","#3a8a7c"
];

export const MONTHS = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
export const MONTH_NAMES = ["January","February","March","April","May","June","July","August","September","October","November","December"];
export const MONTHS_TR = ["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"];


// Mono label style
export const mono = {
  fontFamily: "'JetBrains Mono', monospace",
  fontSize: 10,
  letterSpacing: "0.12em",
  textTransform: "uppercase",
};

// Swiss-style shared tokens
export const T = {
  bg: "#f6f3ee",
  ink: "#111",
  mute: "#888",
  border: "#e0dbd4",
  borderLight: "#ece8e2",
  accent: "#e4572e",
  surface: "#fff",
  surfaceHover: "#f0ece6",
};
